export default function CateringServices() {
  const services = [
    {
      id: 1,
      title: 'Private Events',
      description: 'Intimate dinner parties, family celebrations, and exclusive gatherings crafted with personalized menus and impeccable service.',
      image: 'https://public.readdy.ai/ai/img_res/6ed7c813ab500e9eb6d7ad3981a62bb8.jpg',
      features: ['Custom Menu Design', 'Professional Service Staff', 'Premium Ingredients', 'Flexible Scheduling']
    },
    {
      id: 2,
      title: 'Corporate Catering',
      description: 'Elevate your business events with sophisticated cuisine that impresses clients and motivates teams.',
      image: 'https://readdy.ai/api/search-image?query=upscale%20corporate%20catering%20buffet%20with%20elegant%20food%20displays%20professional%20presentation%20business%20lunch%20gourmet%20dishes%20modern%20clean%20setting%20luxury%20catering%20service&width=600&height=600&seq=service002&orientation=squarish',
      features: ['Board Meetings', 'Product Launches', 'Team Building', 'Client Entertainment']
    },
    {
      id: 3,
      title: 'Wedding Celebrations',
      description: 'Make your special day unforgettable with exquisite cuisine that delights every guest and creates lasting memories.',
      image: 'https://readdy.ai/api/search-image?query=luxury%20wedding%20reception%20dinner%20table%20with%20elegant%20plated%20meals%20beautiful%20table%20settings%20romantic%20atmosphere%20fine%20dining%20wedding%20catering%20sophisticated%20presentation&width=600&height=600&seq=service003&orientation=squarish',
      features: ['Tasting Sessions', 'Dietary Accommodations', 'Full Service', 'Cake & Desserts']
    }
  ];

  return (
    <section id="catering" className="py-12 sm:py-16 md:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12 mb-8 sm:mb-12 lg:mb-16">
          <div>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-gray-900 font-bold leading-tight">
              Bespoke Catering
              <br />
              Services
            </h2>
          </div>
          <div className="flex items-start lg:items-center">
            <p className="text-gray-600 text-sm sm:text-base md:text-lg font-light leading-relaxed max-w-xl">
              From intimate gatherings to grand celebrations, Chef Ziad creates tailored culinary experiences that exceed expectations and leave lasting impressions.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8">
          <div className="lg:col-span-1 bg-[#2A2A2A] rounded-2xl overflow-hidden">
            <div className="p-6 sm:p-8">
              <h3 className="font-serif text-2xl sm:text-3xl text-white font-bold mb-4 sm:mb-6">
                {services[0].title}
              </h3>
              <div className="relative h-48 sm:h-56 md:h-64 rounded-xl overflow-hidden mb-4 sm:mb-6">
                <img
                  src={services[0].image}
                  alt={services[0].title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <p className="text-gray-300 text-sm sm:text-base font-light leading-relaxed mb-4 sm:mb-6">
                {services[0].description}
              </p>
              <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
                {services[0].features.map((feature, index) => (
                  <li key={index} className="flex items-center gap-2 sm:gap-3 text-gray-300 text-xs sm:text-sm">
                    <i className="ri-check-line text-[#C9A961] text-base sm:text-lg"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                className="inline-block text-[#C9A961] text-xs sm:text-sm font-light tracking-wide hover:text-[#B89851] transition-colors cursor-pointer"
              >
                Learn More <i className="ri-arrow-right-line ml-1"></i>
              </a>
            </div>
          </div>

          {services.slice(1).map((service) => (
            <div key={service.id} className="bg-[#F8F6F3] rounded-2xl overflow-hidden">
              <div className="p-6 sm:p-8 text-center">
                <h3 className="font-serif text-2xl sm:text-3xl text-gray-900 font-bold mb-4 sm:mb-6">
                  {service.title}
                </h3>
                <div className="relative h-48 sm:h-56 md:h-64 rounded-xl overflow-hidden mb-4 sm:mb-6 mx-auto max-w-sm">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <p className="text-gray-700 text-sm sm:text-base font-light leading-relaxed mb-4 sm:mb-6">
                  {service.description}
                </p>
                <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8 text-left max-w-xs mx-auto">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-center gap-2 sm:gap-3 text-gray-700 text-xs sm:text-sm">
                      <i className="ri-check-line text-[#C9A961] text-base sm:text-lg"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button className="w-full sm:w-auto px-6 sm:px-8 py-2.5 sm:py-3 bg-[#C9A961] text-white rounded-full text-xs sm:text-sm font-light tracking-wide transition-all hover:bg-[#B89851] whitespace-nowrap cursor-pointer">
                  Get Started
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
